(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hikma-product-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  const product = document.querySelector('.hikma-product');
  if (!product) return;

  // Thumbnail switcher
  const mainImg = product.querySelector('.hikma-product__main-image');
  const thumbs = product.querySelectorAll('.hikma-product__thumb');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const idx = parseInt(this.dataset.imageIndex, 10);
      if (mainImg && window.__hikmaBotanicalsImages && window.__hikmaBotanicalsImages[idx]) {
        // Remove any srcset so the new src actually paints (a leftover srcset
        // would override .src and keep the original image visible).
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = window.__hikmaBotanicalsImages[idx];
      }
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  // Qty stepper
  const qtyInput = product.querySelector('.hikma-product__qty-input');
  product.querySelectorAll('.hikma-product__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const current = parseInt(qtyInput.value, 10) || 1;
      if (this.dataset.action === 'increase') {
        qtyInput.value = current + 1;
      } else if (this.dataset.action === 'decrease' && current > 1) {
        qtyInput.value = current - 1;
      }
    });
  });

  // Variant selector → update price + availability
  const variantSelects = product.querySelectorAll('.hikma-product__select');
  const priceEl = product.querySelector('.hikma-product__price');
  const addBtn = product.querySelector('.hikma-product__add-btn');
  const variantInput = product.querySelector('input[name="id"]');

  function getSelectedVariant() {
    if (!window.__hikmaBotanicalsVariants) return null;
    const selectedOptions = Array.from(variantSelects).map(function(s) { return s.value; });
    return window.__hikmaBotanicalsVariants.find(function(v) {
      return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
    });
  }

  variantSelects.forEach(function(select) {
    select.addEventListener('change', function() {
      const variant = getSelectedVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.ctaText || 'Add to Your Ritual' : 'Sold Out';
      }
    });
  });


  // Purchase options -> selling_plan input + price
  (function () {
    const fs = product.querySelector('.hikma-product__purchase-options');
    if (!fs) return;
    const planInput = fs.querySelector('input[name="selling_plan"]');
    const freq = fs.querySelector('.hikma-product__po-freq');
    function sync() {
      const picked = fs.querySelector('input[name="hk_purchase"]:checked');
      const isSub = !!picked && picked.value !== '';
      if (freq) freq.hidden = !isSub;
      planInput.value = isSub ? (freq ? freq.value : picked.value) : '';
      if (priceEl && picked) priceEl.textContent = picked.dataset.price;
    }
    fs.addEventListener('change', sync);
    sync();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
